import { Card, EventHandler, Label, ModalPopup, PrimaryButton, ReactSelectBox, Search } from '../../../../CommonComponents'
import excel from '../../../../assets/images/Excel.svg'
import './CreateNewOrder.scss'
import PendingOrderGrid from './PendingOrderGrid'
import { DateRangePicker } from 'rsuite';
import UserProfile from 'client/Components/UserProfile';
import moment from 'moment';
import { HOME_ACTIVE_MENU } from 'client/utils/constants/homeGridConstants';
import LoadingWrapper from '../../../../CommonComponents/LoadingWrapper'

interface IProps {
  activeMenu?: string
  handleClick?: any
  onSearchOrder?: any
  filteredOrderList?: any
  onExportExcel?: any
  orderList?: any
  BranchList?: any
  onDateChange?: any
  searchBoxValue?: any
  dateRange?: any
  showUserManagementPopup?: any
  hidePopup?: any
  showGrid?: any
  myOrder?: any
  handleFilterClear?: any
  myOrdersGridFilters?: any
  pendingApprovalGridFilters?: any
  fleetProcessingGridFilters?: any
  serverTotal?: any
  serverPageNumber?: number
  allPendingApprovalGridFilters?: any
  assignedToOption?:any
  selectedAssignedTo?: any
  onAssignedToChange?: any
  activeHomeFilterState?:any
  assignedToTemp?: any
  requestedByTemp?: any
  regionTemp?: any
  costCenterTemp?: any
  updatedByTemp?: any
  setSelectedDispositionKey?: any
  selectedDispositionKey?: any
  setDispositionTypeList?: any
  dispositionTypeList?: any
  isGridCountsLoading: boolean
  buyerNameList?: any
  setSelectedBuyerNameKey?: any
  selectedBuyerNameKey?: any
  setBuyerNameList?: any
  searchByOptions: any
  globalSearchBy: any
  alreadyHasGridFilterValues?: any
  onGlobalSearchByChange: (value: any) => void
  assignedToColList: any
}
const CreateNewOrderContainer = ({ showUserManagementPopup, hidePopup, activeMenu, handleClick, onSearchOrder,
  filteredOrderList, onExportExcel, orderList, BranchList, onDateChange, searchBoxValue, dateRange, showGrid, myOrder, handleFilterClear, myOrdersGridFilters, pendingApprovalGridFilters, fleetProcessingGridFilters,
    serverTotal, serverPageNumber, assignedToOption,
    allPendingApprovalGridFilters,
    selectedAssignedTo,
    onAssignedToChange,
    activeHomeFilterState,
    assignedToTemp,
    requestedByTemp,
    regionTemp,
    costCenterTemp,
    updatedByTemp,
    setSelectedDispositionKey,
    selectedDispositionKey,
    setDispositionTypeList,
    isGridCountsLoading,
    dispositionTypeList,
    buyerNameList,
    setSelectedBuyerNameKey,
    selectedBuyerNameKey,
    setBuyerNameList,
    searchByOptions,
    globalSearchBy,
    onGlobalSearchByChange,
    assignedToColList,
    alreadyHasGridFilterValues
  }: IProps) => {
  return (
    <>
      {
        showUserManagementPopup
          ? <ModalPopup
            ShowModalPopupFooter={false}
            ModalPopupTitle="USER PROFILE"
            ModalPopupType="medium-large"
            ModalPopupName='userprofile-popup'
           data-attribute="CreateNewOrder_Default_ModalPopup">
            <UserProfile closeModalPopup={hidePopup} />
          </ModalPopup>
          : null
      }
      <Card data-attribute="CreateNewOrder_Default_Card">
        <div className='create-new-order-container'>
          <div className='create-new-order-block mb-md-3'>
            {
              orderList.map((item: any, index: any) => {
                return (
                  <EventHandler key={index} onEvent={() => handleClick(item.text)} data-attribute={`CreateNewOrder_${(item?.text || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                    <div className={`create-new-order ${item.icontype} ${activeMenu === item.text ? 'active' : 'create-new-order'}`} data-attribute={`create-new-order_${index}`}>
                      <div className='pull-left'>
                        <p className='order-type'>{item.text}</p>
                        <LoadingWrapper isLoading={isGridCountsLoading} data-attribute="CreateNewOrder_Default_LoadingWrapper">
                        <a className='order-link' href='/' onClick={(e: any) => e.preventDefault()}>{item.link}</a>
                        </LoadingWrapper>
                        {item?.text == HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL &&
                        <p className='super-admin-label'>Super Admin</p>}
                      </div>
                      <div className='pull-right'>
                        <div className='order-icon'>
                          {
                            activeMenu === item.text ?
                              <img src={item.activeIcon} alt='order-icons' /> :
                              <img src={item.icon} alt='order-icons' />
                          }
                        </div>
                      </div>
                    </div>
                  </EventHandler>
                )
              }
              )
            }
          </div>
          {
            <div className='grid-block pt-2'>
              <div className='mb-1 top-section'>
                <p className='mt-1'>ORDERS LIST</p>
                <div className='clearfix mt-2 mb-3'>
                  <div className='pull-left searchblock global-search'>
                    <Label className='mb-0' data-attribute="CreateNewOrder_Default_Label">Search By</Label>
                    <div className='search-dropdown-block'>
                      <ReactSelectBox
                        name='globalSearch'
                        options={searchByOptions}
                        value={globalSearchBy}
                        onChange={onGlobalSearchByChange}
                        className='global-search-drop-down'
                       data-attribute="CreateNewOrder_globalSearch_SearchSelectBox" />  
                      <Search
                        placeholder={`Search By ${globalSearchBy?.label}`}
                        className='searchTextbox'
                        onSearch={(e?: any) => onSearchOrder(e, true)}
                        onBlur={(e?: any) => onSearchOrder(e,false)}
                        onChange={(e?: any) => onSearchOrder(e,false)}
                        value={searchBoxValue}
                       data-attribute="CreateNewOrder_Default_Searchbox" />
                    </div>                   
                  </div>
                  <div className='pull-right datepickerControl create-flow mb-2 mb-sm-0'>
                    {activeMenu === HOME_ACTIVE_MENU?.PENDING_FLEET_PROCESSING &&
                    <div className='assign-to'>
                    <Label data-attribute="CreateNewOrder_Default_Label_2">Assigned To </Label>
                      <ReactSelectBox
                        options={assignedToTemp}
                        value={selectedAssignedTo}
                        onChange={(e?: any, item?: any) => onAssignedToChange(e, item)}
                       data-attribute="CreateNewOrder_Default_SearchSelectBox" />
                    </div>
                    }
                    <DateRangePicker
                      placement='bottomEnd'
                      format="MM/dd/yyyy"
                      character=' - '
                      onChange={onDateChange}
                      value={dateRange}
                      placeholder='MM/DD/YYYY - MM/DD/YYYY'
                      preventOverflow={true}
                      defaultCalendarValue={[new Date(moment().subtract(1, 'months').startOf('month').toDate()), new Date(moment().startOf('month').toDate())]}
                     data-attribute="CreateNewOrder_Default_DateRangePicker" />
                    <PrimaryButton text='Clear Filters' disabled={alreadyHasGridFilterValues()} onClick={handleFilterClear} className='filter-btn ms-2'  data-attribute="CreateNewOrder_Default_Button" />
                    <EventHandler onEvent={onExportExcel} data-attribute="CreateNewOrder_Default_EventHandler_2">
                      <div className='excel-section hide'>
                        <img src={excel} alt='excel' />
                      </div>
                    </EventHandler>
                  </div>
                </div>
              </div>
              <PendingOrderGrid
                filteredOrderList={filteredOrderList}
                BranchList={BranchList}
                activeMenu={activeMenu}
                showGrid={!showGrid}
                myOrder={myOrder}
                pendingApprovalGridFilters={pendingApprovalGridFilters}
                myOrdersGridFilters={myOrdersGridFilters}
                fleetProcessingGridFilters={fleetProcessingGridFilters}
                searchBoxValue={searchBoxValue}
                dateRange={dateRange}
                serverTotal={serverTotal}
                selectedAssignedTo = {selectedAssignedTo}
                allPendingApprovalGridFilters = {allPendingApprovalGridFilters}
                activeHomeFilterState={activeHomeFilterState}
                assignedToTemp = {assignedToColList}
                requestedByTemp = {requestedByTemp}
                regionTemp = {regionTemp}
                costCenterTemp = {costCenterTemp}
                updatedByTemp = {updatedByTemp}
                setSelectedDispositionKey = {setSelectedDispositionKey}
                selectedDispositionKey = {selectedDispositionKey}
                setDispositionTypeList = {setDispositionTypeList}
                setBuyerNameList = {setBuyerNameList}
                dispositionTypeList  = {dispositionTypeList}
                buyerNameList = {buyerNameList}
                setSelectedBuyerNameKey = {setSelectedBuyerNameKey}
                selectedBuyerNameKey = {selectedBuyerNameKey}
                globalSearchBy={globalSearchBy?.value}
                serverPageNumber={serverPageNumber}
              />
            </div>
          }
        </div>
      </Card>
    </>
  )
}

export default CreateNewOrderContainer
